import React, { useContext, useState } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";

import moment from "moment";
import PhoneInput from "react-phone-input-2";
import { reverseGeoCoding } from "@/utils/reverseGeoCoding";
import { validateEmail, validateISDNumber, validateUserName } from "../../../constants/functions";
import { ChevronDown, ChevronLeftArrow, Cross, OrangeCalendar } from "../../../constants/icons";
import {
  COUNTRIES,
  DEBOUNCE_DELAY,
  GENDER,
  SIGN_IN_MODULE,
  SIGN_UP_WITH_PASSWORD_PAGE
} from "../../../constants/variables";
import { useAuth } from "../../../context/AuthContext";
import { CommonDataContext } from "../../../context/CommonDataContext";
import { extractResource } from "../../../helper/extractResource";
import { Button } from "../../UI/Button";
import { getIsDarkMode } from "@/store/slices/webConfig";
import { useSelector } from "react-redux";
import { LocalizationProvider } from "components/V2/atoms/CustomDatePickerV2/LocalizationProvider";
import { AdapterDayjs } from "components/V2/atoms/CustomDatePickerV2/AdapterDayjs";
import { DatePicker } from "components/V2/atoms/CustomDatePickerV2/DatePicker";
import dayjs from "dayjs";
function SignUPLandingPage(props) {
  const { userExist } = useAuth();
  const [timerId, setTimerId] = React.useState<any>(null);
  const [emailError, setEmailError] = React.useState(false);
  const [mobileError, setMobileError] = React.useState(false);
  const [firstNameError, setFirstNameError] = React.useState(false);
  const [lastNameError, setLastNameError] = React.useState(false);
  const [dobError, setDobError] = React.useState(false);
  const [emailAlreadyExists, setEmailAlreadyExists] = React.useState(false);
  const [phoneAlreadyExists, setPhoneAlreadyExists] = React.useState(false);
  const [genderError, setGenderError] = React.useState(false);
  const { resourceData } = props;
  const [ISDcountryCode, setISDcountryCode] = React.useState("in");
  const [phoneErr, setPhoneErr] = useState(false);
  const { webConfig }: any = useContext(CommonDataContext);

  const enableInternationalFlights = webConfig?.enableInternationalFlights;
  const enableDetectGeoLocation = webConfig?.enableInternationalFlights;
  const isDarkMode = useSelector(getIsDarkMode)
  /**
   * @param e: accepts event as a param and validates event input field and sets erros if required
   */
  const main = (e: any) => {
    if (e?.target?.name === "emailID") {
      if (validateEmail(e.target.value)) {
        setEmailError(false);
      } else {
        setEmailError(true);
      }
    }

    if (e?.target?.name === "mobile") {
      if (e.target.value.length === 10) {
        setMobileError(false);
      } else {
        setMobileError(true);
      }
    }

    if (e?.target?.name === "firstName") {
      if (e.target.value.length > 0 && validateUserName(e.target.value)) {
        setFirstNameError(false);
      } else setFirstNameError(true);
    }

    if (e?.target?.name === "lastName") {
      if (e.target.value.length > 0 && validateUserName(e.target.value)) {
        setLastNameError(false);
      } else setLastNameError(true);
    }

    if (e?.target?.name === "gender") {
      if (e.target.value.length > 0) {
        setGenderError(false);
      } else setGenderError(true);
    }

    if (e?.target?.name === "dob") {
      if (e.target.value.length >= 8) {
        setDobError(false);
      } else setDobError(true);
    }
  };

  // ? the debounce function calls the main fucntion after the sepcified delay after user stops typing
  const debounce = (e: any, delay: any) => {
    if (e?.target?.name === "emailID") {
      setEmailError(false);
      setEmailAlreadyExists(false);
    }
    if (e?.target?.name === "mobile") {
      setMobileError(false);
      setPhoneAlreadyExists(false);
    }
    if (e?.target?.name === "firstName") setFirstNameError(false);
    if (e?.target?.name === "lastName") setLastNameError(false);
    if (e?.target?.name === "gender") setGenderError(false);

    if (timerId) {
      clearTimeout(timerId);
      setTimerId(null);
    }

    setTimerId(
      setTimeout(() => {
        main(e);
      }, DEBOUNCE_DELAY)
    );
  };

  /**
   * the function updates the emailOrMobile state with current input value
   * it also triggers the debounce function
   */
  const handleChange = (e) => {
    props.setFormData({
      ...props.formData,
      [e.target.name]: e.target.value
    });

    if (e.target.name === "mobile"){
      props.handleMobile(e);
      if (e.keyCode === 38 || e.keyCode === 40) {
        e.preventDefault();
      }
    } 

    debounce(e, DEBOUNCE_DELAY);
  };

  const handleMobileInput = (inputNumber: string) => {
    if (validateISDNumber(inputNumber)) {
      setPhoneErr(false);
    } else {
      setPhoneErr(true);
    }

    props.setFormData({
      ...props.formData,
      mobile: inputNumber
    });
  };
  /**
   * the function validates form data before submission
   * it sets errors if invalid
   * if valid, it allows the action call
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    // check for and set errors
    if (props.formData.emailID.length == 0) setEmailError(true);
    if (props.formData.mobile.length == 0) setMobileError(true);
    if (props.formData.firstName.length == 0) setFirstNameError(true);
    if (props.formData.lastName.length == 0) setLastNameError(true);
    if (!moment(props.formData.dob, "DD/MM/YYYY", true).isValid()) setDobError(true);
    if (props.formData.gender === "") setGenderError(true);

    // if invalid data, return
    if (
      props.formData.emailID.length == 0 ||
      props.formData.mobile.length == 0 ||
      props.formData.firstName.length == 0 ||
      props.formData.lastName.length == 0 ||
      !moment(props.formData.dob, "MM/DD/YYYY", true).isValid()
    )
      return;

    // if no errors, go to the next page
    if (
      !emailError &&
      !mobileError &&
      !firstNameError &&
      !lastNameError &&
      !dobError &&
      !emailAlreadyExists &&
      !phoneAlreadyExists &&
      !genderError
    ) {
      try {
        const data = {
          email: props.formData.emailID,
          phone: `+${props.formData.mobile}`
        };
        // signup(data);
        let error = false;
        await userExist(data.email).then((emailExist) => {
          if (emailExist) {
            setEmailAlreadyExists(true);
            error = true;
          }
        });
        // await userExist(data.phone).then((phoneExist) => {
        //   if (phoneExist) {
        //     setPhoneAlreadyExists(true);
        //     error = true;
        //   }
        // });
        if (!error) {
          props.handleState(SIGN_UP_WITH_PASSWORD_PAGE);
        }
      } catch (err) {
        console.warn(err);
      }
    }
  };

  const fetchCountryCode = () => {
    if (enableDetectGeoLocation) {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(async (position) => {
          try {
            const { latitude } = position.coords;
            const { longitude } = position.coords;

            const userLocation = await reverseGeoCoding([longitude, latitude]);
            setISDcountryCode(userLocation);
          } catch (errorCode) {
            console.warn(`Error fetching country ISD Code: ${errorCode}`);
          }
        });
      } else {
        console.warn("Geolocation API is not available in this browser.");
      }
    }
  };

  React.useEffect(() => {
    fetchCountryCode();
  }, []);

  // ? returns landing page of sign up module
  return (
    <div className="w-full sm:w-80 m-auto ComponentName_SignUPLandingPage">
      <div className="flex mb-1 -mx-1.5">
        <button
          onClick={() => {
            props.handleModule(SIGN_IN_MODULE);
          }}
        >
          <ChevronLeftArrow />
        </button>

        <p className="font-semibold text-xl mx-3">{extractResource(resourceData, "signUp")}</p>
        <Cross
          className="mt-0.5 cursor-pointer ml-auto mr-1.5"
          onClick={() => {
            props.handleOpen(false);
          }}
        />
      </div>

      <form onSubmit={handleSubmit} method="post">
        <TextField
          error={firstNameError}
          id="outlined-error-helper-text"
          label={extractResource(resourceData, "firstName")}
          defaultValue={props.formData.firstName}
          helperText={firstNameError ? extractResource(resourceData, "invalidFirstName") : ""}
          onChange={handleChange}
          name="firstName"
          fullWidth
          sx={{
            margin: firstNameError ? "14px 0px 0px 0px" : "14px 0px 23px 0px",
            "& .css-md26zr-MuiInputBase-root-MuiOutlinedInput-root": {
              borderRadius: "8px 0px 8px 8px",
              height: "48px"
            }
          }}
        />

        <TextField
          error={lastNameError}
          id="outlined-error-helper-text"
          label={extractResource(resourceData, "lastName")}
          defaultValue={props.formData.lastName}
          helperText={lastNameError ? extractResource(resourceData, "invalidLastName") : ""}
          onChange={handleChange}
          name="lastName"
          fullWidth
          sx={{
            margin: lastNameError ? "4px 0px 0px 0px" : "4px 0px 23px 0px",
            "& .css-md26zr-MuiInputBase-root-MuiOutlinedInput-root": {
              borderRadius: "8px 0px 8px 8px",
              height: "48px"
            }
          }}
        />

        <FormControl
          fullWidth
          sx={{
            margin: "4px 0px 0px 0px",
            borderRadius: "8px 0px 8px 8px"
          }}
        >
          <InputLabel id="demo-simple-select-label">{extractResource(resourceData, "selectGender")}</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={props.formData.gender}
            label={extractResource(resourceData, "selectGender")}
            error={genderError}
            name="gender"
            onChange={handleChange}
            IconComponent={() => (
              <div className="absolute right-3">
                <ChevronDown />
              </div>
            )}
          >
            {GENDER.map((ele, ind) => (
              <MenuItem key={ind} value={ele} className="sign-up-dropdown">
                {ele}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <p
          className={`text-typography-error text-xs mx-3 poppins align-middle pt-1 h-7 ${
            genderError ? "opacity-1" : "opacity-0"
          }`}
        >
          {extractResource(resourceData, "genderErrorText")}
        </p>

        <div className="">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack spacing={3}>
              <DatePicker
                label={extractResource(resourceData, "dob")}
                value={props.formData.dob ? dayjs(props.formData.dob) : null}
                maxDate={dayjs(new Date())}
                format="DD MMM YYYY"
                openTo="year"
                views={["year", "month", "day"]}
                onChange={(newValue) => {
                  props.setFormData({
                    ...props.formData,
                    dob: moment(newValue.$d).format("MM/DD/YYYY")
                  });
                  setDobError(false);
                }}
                components={{
                  OpenPickerIcon: OrangeCalendar
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={dobError}
                    inputProps={{
                      ...params.inputProps,
                      placeholder: extractResource(resourceData, "dob")
                    }}
                  />
                )}
              />
            </Stack>
          </LocalizationProvider>
          <p className={`${dobError ? "text-typography-error text-xs" : "text-sm"} pt-1 ml-3 poppins h-7 `}>
            {dobError
              ? extractResource(resourceData, "dobErrorText")
              : extractResource(resourceData, "specialOfferForDob")}
          </p>
        </div>

        <FormControl fullWidth sx={{ margin: "4px 0px 0px 0px", borderRadius: "8px 0px 8px 8px" }}>
          <InputLabel id="demo-simple-select-label">{extractResource(resourceData, "country")}</InputLabel>
          <Select
            sx={{
              borderRadius: "8px 0px 8px 8px",
              height: "48px",
              ".css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
                marginTop: "12px"
              }
            }}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={props.formData.country}
            label={extractResource(resourceData, "country")}
            name="country"
            onChange={handleChange}
            IconComponent={() => (
              <div className="absolute right-3">
                <ChevronDown />
              </div>
            )}
          >
            {COUNTRIES.map((ele, ind) => (
              <MenuItem key={ind} value={ele} className="sign-up-dropdown">
                {ele}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          error={emailError || emailAlreadyExists}
          id="outlined-error-helper-text"
          label={extractResource(resourceData, "email")}
          defaultValue={props.formData.emailId}
          helperText={
            emailError
              ? extractResource(resourceData, "invalidEmail")
              : emailAlreadyExists
              ? extractResource(resourceData, "emailExists")
              : null
          }
          onChange={handleChange}
          name="emailID"
          type="email"
          fullWidth
          sx={{
            margin: emailError || emailAlreadyExists ? "23px 0px 0px 0px" : "23px 0px 23px 0px",
            "& .css-md26zr-MuiInputBase-root-MuiOutlinedInput-root": {
              borderRadius: "8px 0px 8px 8px",
              height: "48px"
            }
          }}
        />

        <div className="mt-2 mb-2">
          {enableInternationalFlights ? (
            <PhoneInput
              country={ISDcountryCode}
              specialLabel={extractResource(resourceData, "phone")}
              inputProps={{
                name: "mobile",
                maxLength:17
              }}
              onChange={handleMobileInput}
              defaultMask="..................................................................................................."
              enableLongNumbers
              alwaysDefaultMask
              inputStyle={{
                width: "100%",
                height: "46px",
                borderRadius: "8px 0px 8px 8px",
                color: "black"
              }}
              isValid={() => {
                if (phoneAlreadyExists) {
                  return resourceData.phoneExists;
                }
                return true;
              }}
            />
          ) : (
            <TextField
              error={mobileError || phoneAlreadyExists}
              id="outlined-error-helper-text"
              label={resourceData.phone}
              defaultValue={props.formData.mobile}
              helperText={
                mobileError ? resourceData?.invalidMobileNumber : phoneAlreadyExists ? resourceData.phoneExists : null
              }
              onChange={handleChange}
              name="mobile"
              type="number"
              fullWidth
              sx={{
                margin: mobileError || phoneAlreadyExists ? "4px 0px 0px 0px" : "4px 0px 23px 0px",
                "& .css-md26zr-MuiInputBase-root-MuiOutlinedInput-root": {
                  borderRadius: "8px 0px 8px 8px",
                  height: "48px"
                }
              }}
              onKeyDown={handleChange}
            />
          )}

          <p className="text-typography-error text-xs mx-3 mt-1">
            {phoneErr ? extractResource(resourceData, "invalidPhone") : ""}
          </p>
        </div>
        <Button className="w-80" color="primary" type="submit" variant="contained">
          {extractResource(resourceData, "submit")}
        </Button>
      </form>
      <style>
        {`.css-1n2mv2k {
                justify-content: center;
            }
            .css-bkrceb-MuiButtonBase-root-MuiPickersDay-root{
              width: 36px;
            }
            .MuiPickersDay-hiddenDaySpacingFiller {
              width: 36px;
            }
        `}
      </style>
    </div>
  );
}

export default SignUPLandingPage;
